module.exports = __webpack_public_path__ + "media/images/decolar-4de58f74632edaefba64183d7171973e.svg";